import { createContext } from 'react';

// Context value shape:
// [loading, error, patients, fetchPatients, addPatientToCache, updatePatientInCache, removePatientFromCache]
const patientsContext = createContext<any>(null);

export default patientsContext;